import { Text } from '@chakra-ui/react'
import React from 'react'

import { ChatIcon, EmailIcon, PhoneIcon } from '@chakra-ui/icons'
import { useApp, useAppModals, useAuth, useImagesLoaded, useThreadsList } from '@hb/react'
import { MyAssessmentShortcut } from '../../Assessments/MyAssessmentShortcut'
import { BigGreenButton } from '../../Buttons/BigGreenButton'
import { PageHeader } from '../../Header'
import { InfoStack } from '../../Info/InfoFlex'
import { ContactFormModal } from '../../Modals/Contact/ContactFormModal'
import { ScheduleCallModal } from '../../Modals/ScheduleCallModal'
import { PageContainer } from '../PageContainer'
import { ViewHeaderImage } from '../ViewHeaderImage'
import contactImage from './contactImage.png'

export const ContactView: React.FC = () => {
  const { scheduleCall, contactForm } = useAppModals()
  const { onOpen } = useThreadsList()
  const { loaded, onLoad } = useImagesLoaded(1)
  const authUser = useAuth(s => s.authUser)
  const { appName } = useApp()
  return (
    <PageContainer transition="opacity 300ms" opacity={loaded ? 1 : 0}>
      <PageHeader>CONTACT US</PageHeader>
      <ViewHeaderImage src={contactImage} onLoad={onLoad} />
      <InfoStack my={8}>
        {authUser ? (
          <BigGreenButton gap={2} mb={0} onClick={() => onOpen()}>
            <ChatIcon color="white" filter="drop-shadow(1px 1px 2px #00000055)" />
            <Text>Chat with us</Text>
          </BigGreenButton>
        ) : null}
        <BigGreenButton gap={2} mb={0} onClick={() => scheduleCall.open('ContactView')}>
          <PhoneIcon color="white" filter="drop-shadow(1px 1px 2px #00000055)" />
          <Text>Schedule a Call</Text>
        </BigGreenButton>
        <BigGreenButton
          onClick={() => contactForm.open('ContactView')}
          whiteSpace="pre-wrap"
          flexDirection="row"
          gap={2}
          mb={0}>
          <EmailIcon color="white" filter="drop-shadow(1px 1px 2px #00000055)" />
          <Text>Send Us a Message</Text>
        </BigGreenButton>
      </InfoStack>
      {appName === 'app' ? <MyAssessmentShortcut /> : null}
      <ContactFormModal id="ContactView" />
      <ScheduleCallModal id="ContactView" />
    </PageContainer>
  )
}
